const EligibilityFaqContent = [
  {
    title: 'What is required from me to be able to drive with Autzu?',
    info: [
      {
        text: {
          plaintext: 'Must be 21+ years of age'
        }
      },
      {
        text: {
          plaintext:
            'Have a valid full Ontario driver’s license (Class G or above)'
        }
      },
      {
        text: {
          plaintext:
            'Have an active rideshare driver account (such as Uber Driver) '
        }
      }
    ]
  },
  {
    title:
      'Can I drive if I have an international/out of province license?',
    info: [
      {
        pretext:
          'To drive with Autzu in Ottawa, you must have an Ontario driver’s license (Class G or above). We recommend that you exchange your out-of-province or international license before registering for an account with us. '
      },
      {
        link: {
          leadingText:
            'In Ontario, you can obtain your license 60 days after you’ve moved to the province. For more information on how you can switch your license from another province, visit ',
          title: 'Service Ontario',
          href:
            'https://www.ontario.ca/page/exchange-out-province-drivers-licence',
          trailingText: '.'
        }
      }
    ]
  }
];

export default EligibilityFaqContent;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/EligibilityFaqContentOTT.js